import { render, staticRenderFns } from "./changeItems.vue?vue&type=template&id=8552f900"
import script from "./changeItems.vue?vue&type=script&lang=js"
export * from "./changeItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports